import axios from 'axios';
import { getProject } from './gcloud/getProject';

export default async function userExists(email, projectUrl = getProject(), httpRequest = axios) {
    const resp = await httpRequest({
      url: `${projectUrl}/userExistsV2`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      data: JSON.stringify({ email })
    })
    
    return resp.data
}